import {Injectable} from '@angular/core';

import {ContentType} from '@app/player/scheduler.service.base';

/**
 * Coordinates an HDMI picture-in-picture overlay with playlist playback.
 *
 * The default implementation is a no-op: only platforms that actually drive an HDMI PiP window
 * (Tizen) override it. See the Tizen `PipControlService` for the real behavior.
 */
@Injectable({providedIn: 'root'})
export class PipControlServiceBase {
    /**
     * Prepares the PiP for the content about to play and returns whether the caller must restart the
     * layout (stop + re-prepare) for this transition. No-op default returning false; platforms with
     * an HDMI PiP overlay override it.
     */
    prepareForContent(_type: ContentType): Promise<boolean> {
        return Promise.resolve(false);
    }
}
